export default {
  data () {
    return {
      loadingRequests: false,
      loadingOpenings: false,
      loadingAccounts: false
    }
  },
  methods: {
    async fetchAllVirtualAccountRequests () {
      this.loadingRequests = true
      await this.$store
        .dispatch('transactions/getVirtualAccountRequests')
        .then(() => {
          this.loadingRequests = false
        })
        .catch((error) => {
          this.loadingRequests = false
          const err = error.response
            ? error?.response?.data?.error?.publicMessage
            : error
          this.$notify({
            title: this.httpErrorMessage.customMessage,
            message: err || '',
            type: 'error'
          })
        })
    },
    async getVirtualAccountOpenings () {
      this.loadingOpenings = true
      await this.$store
        .dispatch('transactions/getVirtualAccountOpenings')
        .then(() => {
          this.loadingOpenings = false
        })
        .catch((error) => {
          this.loadingOpenings = false
          const err = error.response
            ? error?.response?.data?.error?.publicMessage
            : error
          this.$notify({
            title: this.httpErrorMessage.customMessage,
            message: err || '',
            type: 'error'
          })
        })
    },
    async getFrozenAccountBalances () {
      this.loadingAccounts = true
      await this.$store
        .dispatch('report/getFrozenAccountBalances', 'frozen')
        .then(() => {
          this.loadingAccounts = false
        })
        .catch((error) => {
          const err = error.response
            ? error?.response?.data?.error?.publicMessage
            : error
          this.$notify({
            title: this.httpErrorMessage.customMessage,
            message: err || '',
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
        .finally(() => {})
    }
  },
  computed: {
    virtualAccountRequests () {
      return this.$store.state.transactions.virtualAccountRequests || []
    },
    virtualAccountOpenings () {
      return this.$store.state.transactions.virtualAccountOpenings || []
    },
    pendingVirtualAccountRequests () {
      // sort accounts in alphabetical order by their currency
      const accounts = this.virtualAccountRequests.filter(
        (request) => request.status === 'pending'
      )
      const sortedAccounts = accounts
        .slice()
        .sort((a, b) => a.currency.localeCompare(b.currency))

      return sortedAccounts || []
    },
    activeVirtualAccounts () {
      // sort accounts in alphabetical order by their currency
      const accounts = this.virtualAccountOpenings.filter(
        (account) => account.status === 'active'
      )
      const sortedAccounts = accounts
        .slice()
        .sort((a, b) => a.currency.localeCompare(b.currency))

      return sortedAccounts || []
    },
    frozenVirtualAccounts () {
      // sort accounts in alphabetical order by their currency
      const accounts = this.$store.state.report.frozenAccountBalances || []
      const sortedAccounts = accounts
        .slice()
        .sort((a, b) => a.currency.localeCompare(b.currency))

      return sortedAccounts || []
    }
  }
}
